'use strict'
import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import pannier from './pannier'
import product from './product'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    pannier,
    product
  }
})
